"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSelection = exports.isValidCarPrice = exports.isValidBirthDate = exports.isValidPhone = exports.isValidCpf = exports.onlyNumbers = exports.isValidName = void 0;
const R = __importStar(require("ramda"));
const dates_1 = require("../dates");
const MAJORITY = 18;
const MIN_PRICE = 1000;
const MAX_PRICE = 3000000;
const CELLPHONE_EXPECTED_LENGTH = 15;
const DATE_EXPECTED_LENGTH = 10;
const isValidName = (value = '', maxLength) => {
    if (R.isEmpty(value)) {
        return false;
    }
    if (value.length > maxLength) {
        return false;
    }
    const cleanValue = value.trim();
    const names = cleanValue.split(' ');
    if (names && names.length >= 2 && names.every(elem => elem.length >= 2)) {
        return true;
    }
    return false;
};
exports.isValidName = isValidName;
const onlyNumbers = (str) => {
    const numbers = str && str.match(/\d/g);
    return numbers && numbers.join('');
};
exports.onlyNumbers = onlyNumbers;
const isValidCpf = (stringCpf) => {
    const cpfValue = stringCpf ? (0, exports.onlyNumbers)(stringCpf) : '';
    let cpfSum;
    let cpfRest;
    cpfSum = 0;
    if (cpfValue !== undefined && cpfValue.length >= 11) {
        if (cpfValue === '00000000000' ||
            cpfValue === '11111111111' ||
            cpfValue === '22222222222' ||
            cpfValue === '33333333333' ||
            cpfValue === '44444444444' ||
            cpfValue === '55555555555' ||
            cpfValue === '66666666666' ||
            cpfValue === '77777777777' ||
            cpfValue === '88888888888' ||
            cpfValue === '99999999999') {
            return false;
        }
        for (let i = 1; i <= 9; i += 1) {
            cpfSum += parseInt(cpfValue.substring(i - 1, i)) * (11 - i);
        }
        cpfRest = (cpfSum * 10) % 11;
        if (cpfRest === 10 || cpfRest === 11)
            cpfRest = 0;
        if (cpfRest !== parseInt(cpfValue.substring(9, 10)))
            return false;
        cpfSum = 0;
        for (let i = 1; i <= 10; i += 1) {
            cpfSum += parseInt(cpfValue.substring(i - 1, i)) * (12 - i);
        }
        cpfRest = (cpfSum * 10) % 11;
        if (cpfRest === 10 || cpfRest === 11)
            cpfRest = 0;
        if (cpfRest !== parseInt(cpfValue.substring(10, 11)))
            return false;
        return true;
    }
    return false;
};
exports.isValidCpf = isValidCpf;
const isValidPhone = (stringPhone) => {
    if (!stringPhone)
        return false;
    if (stringPhone.length < CELLPHONE_EXPECTED_LENGTH)
        return false;
    const phoneRegex = /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}-[0-9]{4}$/;
    return phoneRegex.test(stringPhone);
};
exports.isValidPhone = isValidPhone;
const isValidBirthDate = (stringBirthDate, createError) => {
    if (!stringBirthDate)
        return false;
    const parsedBirthDate = stringBirthDate.replaceAll('_', '');
    if (parsedBirthDate.length < DATE_EXPECTED_LENGTH)
        return false;
    const handleBirthDate = parsedBirthDate.split('/').reverse().join('-');
    const today = new Date();
    const birthDate = new Date(handleBirthDate);
    const result = (0, dates_1.differenceInYears)(today, birthDate);
    if (!result)
        return createError({ message: 'Data inválida' });
    if (result < MAJORITY)
        return createError({ message: 'Deve ser maior de 18 anos' });
    return true;
};
exports.isValidBirthDate = isValidBirthDate;
const isValidCarPrice = (value, createError) => {
    if (value === undefined || value === '')
        return createError({ message: 'Valor inválido' });
    if (value < MIN_PRICE)
        return createError({ message: 'Valor mínimo de R$ 1.000,00' });
    if (value > MAX_PRICE)
        return createError({ message: 'Valor máximo de R$ 3.000.000,00' });
    return true;
};
exports.isValidCarPrice = isValidCarPrice;
const isValidSelection = (selection) => {
    return R.prop('value', selection) && R.prop('label', selection);
};
exports.isValidSelection = isValidSelection;
//# sourceMappingURL=index.js.map